import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';
import { Modal } from '@/ui/kit/components/modal';
import { PDPEvents } from '@/misc/event-enums';
import { appDetails } from '@/utils/configs';
const InvestmentCounseling = () => {
  const texts = {
    title: 'مشاوره',
    titleBTN: 'تماس با مشاور',
    desc: `${'اگر برای سرمایه‌گذاری در طرح نیاز به مشاوره و راهنمایی بیشتری دارید، میتوانید با شماره '}${appDetails.supportPhoneLabelRTL} ${'تماس بگیرید.'}`
  };
  const [isOpen, setIsOpen] = useState(false);
  return <>
      <Button sx={{
      flex: 1
    }} variant='outlined' color='info' onClick={() => setIsOpen(true)} data-gtm-button-id={PDPEvents.Counseling} data-sentry-element="Button" data-sentry-source-file="InvestmentCounseling.tsx">
        {texts.title}{' '}
      </Button>
      <Modal title={texts.title} open={isOpen} onClose={() => setIsOpen(false)} data-sentry-element="Modal" data-sentry-source-file="InvestmentCounseling.tsx">
        <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        rowGap: 'var(--spacing_m)',
        maxWidth: '456px',
        minWidth: {
          xs: 'unset',
          md: '456px'
        },
        margin: 'auto',
        p: 'var(--spacing_l)'
      }} data-sentry-element="Box" data-sentry-source-file="InvestmentCounseling.tsx">
          <>
            <Typography variant='bodyRegular__Wallfund' color='text.text' data-sentry-element="Typography" data-sentry-source-file="InvestmentCounseling.tsx">
              {texts.desc}
            </Typography>
            <Box display='flex' data-sentry-element="Box" data-sentry-source-file="InvestmentCounseling.tsx">
              <Button variant='contained' color='primary' size='large' sx={{
              flex: 1,
              height: '48px',
              borderColor: 'primary'
            }} href={`tel:${appDetails.supportPhone}`} data-gtm-button-id={PDPEvents.CounselingCall} data-sentry-element="Button" data-sentry-source-file="InvestmentCounseling.tsx">
                {texts.titleBTN}
              </Button>
            </Box>
          </>
        </Box>
      </Modal>
    </>;
};
export default InvestmentCounseling;